// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"7e724c24","173":"77cc4b67","718":"5344d7ae","794":"99ea3753"}[chunkId] + ".chunk.css";
};